import { declareFieldMeanings, means } from '../../../src/issues/field-meanings';

/** What the one Street View observation detail means to an owner. */
export const fieldMeanings = declareFieldMeanings({
  sources: ['us-street-view'],
  declarations: [
    means('date', 'the month of the latest Street View capture', ['captureMonth'], {
      matters: 'means the street was photographed again',
    }),
  ],
});
